<template>
  <div class="popup small">
    <Loader v-if="loading" />
    <h4 class="popup__title middle">{{ isClientManager ? 'Удаление менеджера клиента' : 'Удаление пользователя' }}</h4>

    <span class="popup__subtitle">
      {{ isClientManager ? 'Вы точно желаете удалить данного менеджера клиента?' : 'Вы точно желаете удалить данного пользователя?' }}
    </span>

    <div class="actions">
      <button class="button btn-primary" @click="closeAll()">Отмена</button>
      <button class="button btn-primary" @click="deleteUser()">Удалить</button>
    </div>
  </div>
</template>

<script>
import {popups} from '@/mixins/popups'
import {mapActions, mapState} from "vuex";
import Loader from '@/components/common/Loader.vue'

export default {
  name: "removeUserPopup",
  mixins: [popups],
  components: {
    Loader
  },
  data: () => ({
    loading: false
  }),
  computed: {
    ...mapState({
      user: state => state.popups.user,
    }),
    isClientManager() {
      return this.user?.actionType === 'clientManagersManagement'
    }
  },
  methods: {
    ...mapActions({
      removeUser: 'removeUser',
      deleteClientManager: 'deleteClientManager',
    }),
    async deleteUser() {
      this.loading = true
      const id = this.user.ID || this.user.id
      if (this.isClientManager) {
        await this.deleteClientManager(id)
      } else {
        await this.removeUser(id)
      }

      this.loading = false
      //this.closeAll()
    },
  },
  mounted() {}
}
</script>

<style scoped lang="scss">
@import "../../styles/variables";

.popup {
  :deep(.loader) {
    height: 200%;
    width: 200%;
    left: -50%;
    top: -50%;
    border-radius: 25px;
    transform: scale(0.5);
    svg {
      position: unset;
    }
  }
}
</style>